import { Helmet } from 'react-helmet-async';
import { Layout } from '../components/layout';
import {
  Hero,
  Services,
  HowItWorks,
  Impact,
  Industries,
  WhyPunarvaa,
  Clients,
  CTA,
} from '../components/home';

const SITE_URL = 'https://www.patekarecycle.com';

export function Home() {
  return (
    <Layout>
      <Helmet>
        <title>Punarvaa | Structured Waste Recovery Systems | Patekar Recycle</title>
        <meta name="title" content="Punarvaa | Structured Waste Recovery Systems | Patekar Recycle" />
        <meta
          name="description"
          content="Punarvaa by Patekar Recycle Solution Pvt Ltd builds structured systems to recover value from waste. Compliant waste management, recycling, and resource recovery solutions for industries, retailers, and communities."
        />
        <meta
          name="keywords"
          content="Punarvaa, Patekar Recycle, waste management India, resource recovery, recycling solutions, EPR compliance, integrated waste management, circular economy, ESG reporting"
        />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />

        <link rel="canonical" href={`${SITE_URL}/`} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:title" content="Punarvaa | Structured Waste Recovery Systems | Patekar Recycle" />
        <meta
          property="og:description"
          content="Punarvaa by Patekar Recycle Solution Pvt Ltd builds structured systems to recover value from waste. For businesses, cities, and the planet."
        />
        <meta property="og:site_name" content="Punarvaa by Patekar Recycle" />
        <meta property="og:image" content={`${SITE_URL}/images/og-image.png`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_IN" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@patekarrecycle" />
        <meta name="twitter:url" content={`${SITE_URL}/`} />
        <meta name="twitter:title" content="Punarvaa | Structured Waste Recovery Systems" />
        <meta
          name="twitter:description"
          content="Punarvaa by Patekar Recycle Solution Pvt Ltd builds structured systems to recover value from waste."
        />
        <meta name="twitter:image" content={`${SITE_URL}/images/og-image.png`} />

        <meta name="geo.region" content="IN" />
        <meta name="geo.placename" content="India" />
      </Helmet>

      <Hero />
      <Services />
      <HowItWorks />
      <Impact />
      <Industries />
      <WhyPunarvaa />
      <Clients />
      <CTA />
    </Layout>
  );
}
